import ProfileBasis from './ProfileBasis';

export default ProfileBasis;
